import {createClient} from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  projectId: "lbxr1eyi",
  dataset: "production",
  apiVersion: "2023-03-20",
  useCdn: true,
  token:
    "skyezTf21TXtdhqmNV4BfRFLP5ruteQs7AA0k9JFWKl5vxTtyRzEnvHMHvRGfmeMSiX6CuQiJvraGPa0dthsaVInJSoKcHi8nUxEPLziIWvtt0G3iPWg8QOiyeR7E0dNMVESZEz74NkheCsACOGqppw6trtlER5AgJ1yAHtuJ0kn3GDnWfUx",
});

//const builder = imageUrlBuilder(client);

//export const urlFor = (source) => builder.image(source);


const builder = imageUrlBuilder(client)

// Then we like to make a simple function like this that gives the
// builder an image and returns the builder for you to specify additional
// parameters:
export function urlFor(source) {
  if (!source) {
    return null; // Return null if source is undefined
  }
  return builder.image(source);
}